var React = require('react');

function GreyLinkedinInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3.13086 4.375H0V14H3.13086V4.375Z","fill":"#9A9A9A","key":0}),React.createElement("path",{"d":"M11.6587 4.48779C11.6245 4.47754 11.5938 4.46728 11.5596 4.45703C11.5186 4.44678 11.4741 4.43994 11.4331 4.43311C11.2656 4.39893 11.0845 4.375 10.8726 4.375C9.04736 4.375 7.88867 5.70117 7.50928 6.21387V4.375H4.375V14H7.50586V8.75C7.50586 8.75 9.87109 5.45508 10.8691 7.875V14H14V7.50586C14 6.0498 13.002 4.83984 11.6587 4.48779Z","fill":"#9A9A9A","key":1}),React.createElement("path",{"d":"M3.0625 1.53125C3.0625 2.37549 2.37549 3.0625 1.53125 3.0625C0.687012 3.0625 0 2.37549 0 1.53125C0 0.687012 0.687012 0 1.53125 0C2.37549 0 3.0625 0.687012 3.0625 1.53125Z","fill":"#9A9A9A","key":2})]);
}

GreyLinkedinInline.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = GreyLinkedinInline;

GreyLinkedinInline.default = GreyLinkedinInline;
